import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { InviteCodeCard } from "../../../components/view/user-panel/friends-introduction/invite-code-card";
import { SuccessfulInviteList } from "../../../components/view/user-panel/friends-introduction/invite-list";
import BasePagination from "../../../components/common/base-pagination/base-pagination";
import BASE_URL from "../../../constants/baseUrls";
import Loading from "../../../components/common/loading/loading";
import { toast } from "react-toastify";
import { IS_MOBILE } from "../../../constants/breakpoints";
import BaseTitle from "../../../components/common/base-title/base-title";
import { useTranslation } from "react-i18next";

const FriendsIntroduction = () => {
    const { t } = useTranslation();

    const [invites, setInvites] = useState([]);
    const [inviteCode, setInviteCode] = useState("");
    const [loading, setLoading] = useState(true);
    const [userInfoLoading, setUserInfoLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        page: 1,
        totalPages: 1,
        count: 0,
    });
    const accessToken = localStorage.getItem("accessToken");

    // Calculate pageSize based on API response
    // const pageSize = pagination.count > 0
    //     ? Math.ceil(pagination.count / pagination.totalPages)
    //     : 10;

    const pageSize = 20;

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/v2/account/user/info/`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                setInviteCode(response.data.data.representative_code);
                setUserInfoLoading(false);
            } catch (err) {
                toast.error("خطا در دریافت اطلاعات کاربر", { toastId: "custom-id-yes" });
                setUserInfoLoading(false);
            }
        };

        fetchUserInfo();
    }, []);

    const fetchInvites = async (page = 1) => {
        try {
            setLoading(true);
            const response = await axios.get(`${BASE_URL}/api/v2/account/user/friends-list/?page=${page}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const data = response.data.data;
            setInvites(data.results);
            setPagination({
                page: data.current_page,
                totalPages: data.total_pages,
                count: data.count,
            });
            setLoading(false);
        } catch (err) {
            setError("Failed to fetch invites");
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvites();
    }, []);

    const handlePageChange = (event, page) => {
        fetchInvites(page);
    };

    return (
        <Box
            sx={{
                mt: 2,
                width: "100%",
                maxWidth: "100%",
                padding: 0,
                margin: 0,
            }}
        >
            {!IS_MOBILE && <BaseTitle title={`${t("friendsIntroduction")}`} dividerColor="1px solid var(--medium-gray-color)" />}
            <Box
                sx={{
                    maxWidth: { xs: "100%", sm: "80%", md: "600px" },
                    margin: "0 auto",
                    px: { xs: 2, md: 0 },
                    mt: "20px",
                }}
            >
                {userInfoLoading ? <Loading /> : <InviteCodeCard code={inviteCode} />}
            </Box>
            {loading ? (
                <Loading />
            ) : error ? (
                <Typography color="error" sx={{ paddingX: { xs: 2, md: 4 } }}>
                    {error}
                </Typography>
            ) : (
                <>
                    <SuccessfulInviteList invites={invites} currentPage={pagination.page} pageSize={pageSize} />
                    {pagination.totalPages > 1 && (
                        <BasePagination count={pagination.totalPages} page={pagination.page} handleChange={handlePageChange} />
                    )}
                </>
            )}
        </Box>
    );
};


export default FriendsIntroduction;
